import { render, staticRenderFns } from "./LeadingCategories.vue?vue&type=template&id=1cb3cd79"
import script from "./LeadingCategories.vue?vue&type=script&lang=js"
export * from "./LeadingCategories.vue?vue&type=script&lang=js"
import style0 from "./LeadingCategories.vue?vue&type=style&index=0&id=1cb3cd79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports